import { render, staticRenderFns } from "./PdfInvoice.vue?vue&type=template&id=1deebdab&scoped=true&"
import script from "./PdfInvoice.vue?vue&type=script&lang=ts&"
export * from "./PdfInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./PdfInvoice.vue?vue&type=style&index=0&id=1deebdab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deebdab",
  null
  
)

export default component.exports